jQuery(document).ready(function () {


    let swiperCarouselBlog = new Swiper(".Community", {
        slidesPerView: 4,
        spaceBetween: 24,
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
        },
        breakpoints: {
            250: {
                slidesPerView: 1.18,
                spaceBetween: 16
            },
            400: {
                slidesPerView: 1.75,
                spaceBetween: 16
            },
            500: {
                slidesPerView:1.90,
                spaceBetween: 16
            },
            600: {
                slidesPerView:2,
                spaceBetween: 16
            },
            700: {
                slidesPerView:2.50,
                spaceBetween: 16
            },
            800: {
                slidesPerView:2.85,
                spaceBetween: 16
            },
            950: {
                slidesPerView: 2.90,
                spaceBetween: 16
            },
            1000: {
                slidesPerView: 3.30,
                spaceBetween: 16
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16,
                slidesPerGroup: 0,
                allowTouchMove:false,
            }

        }
    });
});